import { all } from 'redux-saga/effects';
import { WatchersBuilder } from '../../../../utils/sagas/WatchersBuilder';
import { environment } from '../../../../environments/environment';
import { DO_ACTION, IDENTIFIER } from '../actions';
import { doAction } from '../../api';
import { navigateToReportedConversationsList } from './workers';

export default function* () {
    yield all([
        ...WatchersBuilder.buildList(
            IDENTIFIER,
            environment.api.feedback.reportedConversations,
            {
                create: { apiCall: false },
                update: { apiCall: false },
                delete: { apiCall: false }
            }
        ),
        ...WatchersBuilder.buildGetSingle(
            IDENTIFIER,
            environment.api.feedback.reportedConversations
        ),
        WatchersBuilder.build(
            IDENTIFIER,
            DO_ACTION,
            doAction,
            navigateToReportedConversationsList
        )
    ]);
}
